import sceneApi from '../../apis/scene';
let hostspotListPromise = {};
let getCarVrInfoBySeriesIdPromise = {};
export default {
  state: {
    currentScene: '',
    sceneList: [{ thumbUrl:'', title:'', id:0}],
    hotspotList: [],
    carVrInfoList: []
  },
  mutations: {
    setSceneList (state, sceneList) {
      state.sceneList = [];
      sceneList.forEach(element => {
        if (element.visualBooth !== 1) {
          state.sceneList.push(element);
        }
      });
    },
    setCurrentScene (state, sceneName) {
      state.currentScene = sceneName;
    },
    setHotspotList (state, { dealerId, sceneId, cityId, list }) {
      state.hotspotList.push({ dealerId, sceneId, cityId, list });
    },
    setCarVrInfoList (state, { seriesId, vrInfo }) {
      state.carVrInfoList.push({ seriesId, vrInfo });
    }
  },
  getters: {
    sceneList: state => state.sceneList,
    currentScene: state => state.currentScene,
    sceneCls: state => state.sceneCls,
    hotspotList: state => (sceneId) => {
      const element = state.hotspotList.find(o => o.sceneId === sceneId);
      if (element) {
        return element.list || [];
      }
      return [];
    },
    carVrInfo: state => (seriesId) => {
      const element = state.carVrInfoList.find(o => o.seriesId === seriesId);
      if (element) {
        return element.vrInfo || null;
      }
      return null;
    }
  },
  actions: {
    getHotSpotList ({ commit }, { dealerId, sceneId, cityId }) {
      let key = `getHotSpotList_${dealerId}_${sceneId}_${cityId}`;
      if (!hostspotListPromise[key]) {
        hostspotListPromise[key] = sceneApi.
          getHotSpotList({ dealerId, sceneId, cityId })
          .then(function (data) {
            commit('setHotspotList', { dealerId, sceneId, cityId, list: data.list });
            return data.list;
          });
      }
      return hostspotListPromise[key];
    },
    getCarVrInfoBySeriesId ({ commit }, { seriesId }) {
      if (!getCarVrInfoBySeriesIdPromise[seriesId]) {
        getCarVrInfoBySeriesIdPromise[seriesId] = sceneApi
          .getCarVrInfoBySeriesId({ seriesId })
          .then(data => {
            commit('setCarVrInfoList', { seriesId, vrInfo: data });
            return data;
          }).catch(function (ex) {
            console.log(ex);
            return null;
          });
      }
      return getCarVrInfoBySeriesIdPromise[seriesId];
    }
  },
  namespaced: true
};
